import zpaForm from './form'
import zpaFormGroup from './form-group'
import zpaFormItem from './form-item'

import zpaTextInput from './input-text'
import zpaText from './text'
import zpaRichTextInput from './rich-text'
import zpaNumberInput from './input-number'
import zpaDateInput from './input-date'
import zpaDateRangeInput from './input-date-range'
import zpaRadioGroup from './radio-group'
import zpaCheckboxGroup from './checkbox-group'
import zpaSwitch from './switch'
import zpaSelect from './select'
import zpaCascader from './cascader'
import zpaTreeSelect from './tree-select'
import zpaTextarea from './textarea'
import zpaSlider from './slider'
import zpaColorPicker from './color'
import zpaAutoComplete from './auto-complete'
import zpaHighlight from './highlight'
import zpaTimeline from './timeline'

const App = {}

App.install = function(Vue) {
  Vue.component('zpaForm', zpaForm)
  Vue.component('zpaFormGroup', zpaFormGroup)
  Vue.component('zpaFormItem', zpaFormItem)
  Vue.component('zpaAutoComplete', zpaAutoComplete)

  Vue.component('zpaTextInput', zpaTextInput)
  Vue.component('zpaText', zpaText)
  Vue.component('zpaRichTextInput', zpaRichTextInput)
  Vue.component('zpaNumberInput', zpaNumberInput)
  Vue.component('zpaDateInput', zpaDateInput)
  Vue.component('zpaDateRangeInput', zpaDateRangeInput)
  Vue.component('zpaRadioGroup', zpaRadioGroup)
  Vue.component('zpaCheckboxGroup', zpaCheckboxGroup)
  Vue.component('zpaSwitch', zpaSwitch)
  Vue.component('zpaSelect', zpaSelect)
  Vue.component('zpaCascader', zpaCascader)
  Vue.component('zpaTreeSelect', zpaTreeSelect)
  Vue.component('zpaTextarea', zpaTextarea)
  Vue.component('zpaSlider', zpaSlider)
  Vue.component('zpaColorPicker', zpaColorPicker)
  Vue.component('zpaHighlight', zpaHighlight)
  Vue.component('zpaTimeline', zpaTimeline)
}

App.components = {
  zpaForm,
  zpaFormGroup,
  zpaFormItem,
  zpaAutoComplete,
  zpaTextInput,
  zpaText,
  zpaRichTextInput,
  zpaNumberInput,
  zpaDateInput,
  zpaDateRangeInput,
  zpaRadioGroup,
  zpaCheckboxGroup,
  zpaSwitch,
  zpaSelect,
  zpaCascader,
  zpaTreeSelect,
  zpaTextarea,
  zpaSlider,
  zpaColorPicker,
  zpaHighlight,
}

export default App

export const Form = zpaForm
export const FormGroup = zpaFormGroup
export const FormItem = zpaFormItem
export const AutoComplete = zpaAutoComplete
export const TextInput = zpaTextInput
export const Text = zpaText
export const RichTextInput = zpaRichTextInput
export const NumberInput = zpaNumberInput
export const DateInput = zpaDateInput
export const DateRangeInput = zpaDateRangeInput
export const RadioGroup = zpaRadioGroup
export const CheckboxGroup = zpaCheckboxGroup
export const Switch = zpaSwitch
export const Select = zpaSelect
export const TreeSelect = zpaTreeSelect
export const Textarea = zpaTextarea
export const Slider = zpaSlider
export const ColorPicker = zpaColorPicker
